import React from "react";
import { motion } from "framer-motion";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";
import EntregaFacilCard from "./logisticIntegrations/EntregaFacilCard";
import {
  AnimatedModal,
  ModalContent,
  ModalHeader,
} from "../modals/AnimatedModal";
import UberDirectCard from "./logisticIntegrations/uber/UberDirectCard";

// Animation variants
const contentVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { delay: 0.2, duration: 0.4 },
  },
};

const DeliveryIntegrationsListModal = ({ show, closeModal }) => {
  return (
    <AnimatedModal
      isOpen={show}
      onClose={closeModal}
      width="75%"
      maxWidth="1200px"
    >
      <ModalHeader
        title="Integrações Logísticas"
        icon={IntegrationInstructionsIcon}
        onClose={closeModal}
      />
      <ModalContent padding={0}>
        <Box sx={{ p: 3 }}>
          <motion.div
            variants={contentVariants}
            initial="hidden"
            animate="visible"
          >
            <Grid container spacing={3}>
              {/* Uber Direct Card */}
              <Grid item xs={12} md={6}>
                <UberDirectCard />
              </Grid>

              {/* Entrega Fácil Card (existing integration) */}
              <Grid item xs={12} md={6}>
                <EntregaFacilCard />
              </Grid>
            </Grid>
          </motion.div>
        </Box>
      </ModalContent>
    </AnimatedModal>
  );
};

export default DeliveryIntegrationsListModal;
